import { render, staticRenderFns } from "./customershop.vue?vue&type=template&id=69cc1081"
import script from "./customershop.vue?vue&type=script&lang=js"
export * from "./customershop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports